import { Link } from "components/link";
import clsx from "clsx";
import { HoverEffect } from "components/layout/header.desktop-nav.hover-effect";

import { HEADER } from "content/layout";
import { useRouter } from "next/router";
import { FC } from "react";

import img from "@/components/Education/offer.jpg";
import Image from "next/image";

export const DesktopNav: FC = () => {
  const router = useRouter();
  return (
    <>
      <nav className="sm:w-[190%] lg:w-[100%] sm:ml-[-15vw] lg:m-auto sm:scrollbar-none header-nav group relative isolate mt-auto hidden h-full justify-center overflow-auto px-2 md:flex overflow-x-visible"
      >
        <HoverEffect />
        {HEADER.nav
          .filter(({ desktop }) => desktop)
          .map((link, i) => {
            const isActive = router.asPath.split(/[#?]/)[0] === link.href;
            return (
              <div
                className="my-auto flex h-full items-center px-2"
                key={link.href + link.title + i}
              >
                <Link
                  href={link.href}
                  className={clsx(
                    "w-15/100 relative z-10 flex rounded-md border-2 border-transparent px-4 py-1.5 text-gray-500 outline-none transition-all hfa:text-gray-900 hfa:outline-none d:text-gray-300 d:hfa:text-gray-50",
                    isActive &&
                      "border-slate-700/5 bg-slate-100 bg-clip-padding d:border-slate-50/10 d:bg-slate-800 group-hfa:bg-slate-200/30"
                  )}
                >
                  <span className="text-sm font-medium ">{link.title}</span>
                  {link.title === "Education" && (
                    <div className="absolute -right-2 -top-2 inline-flex h-6 w-6 animate-bounce items-center justify-center">
                      <Image src={img} alt="offer" className="rounded" />
                    </div>
                  )}
                </Link>
              </div>
            );
          })}
      </nav>
    </>
  );
};
